(function (window, document) {
  'use strict';

  if (window.initMiyoSliders) {
    window.initMiyoSliders();
    return;
  }

  var instances = typeof WeakMap === 'function' ? new WeakMap() : null;
  var fallbackInstances = [];

  function toNumber(value, fallback) {
    var n = parseFloat(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function getConfig(root) {
    return {
      loop: root.getAttribute('data-loop') === 'true',
      duration: toNumber(root.getAttribute('data-duration'), 400),
      gap: toNumber(root.getAttribute('data-gap'), 0),
      gapMobile: toNumber(
        root.getAttribute('data-gap-mobile'),
        toNumber(root.getAttribute('data-gap'), 0)
      ),
      slidesPerView: root.getAttribute('data-slides-per-view') || '1',
      slidesPerViewTablet:
        root.getAttribute('data-slides-per-view-tablet') ||
        root.getAttribute('data-slides-per-view') ||
        '1',
      slidesPerViewMobile:
        root.getAttribute('data-slides-per-view-mobile') ||
        root.getAttribute('data-slides-per-view') ||
        '1',
      centered: root.getAttribute('data-centered') === 'true',
      centeredTablet: root.getAttribute('data-centered-tablet') === 'true',
      centeredMobile: root.getAttribute('data-centered-mobile') === 'true'
    };
  }

  function getViewport(config) {
    var width = window.innerWidth;
    if (width >= 1024) {
      return {
        slidesPerView: config.slidesPerView,
        gap: config.gap,
        centered: config.centered
      };
    }
    if (width >= 768) {
      return {
        slidesPerView: config.slidesPerViewTablet,
        gap: config.gapMobile,
        centered: config.centeredTablet
      };
    }
    return {
      slidesPerView: config.slidesPerViewMobile,
      gap: config.gapMobile,
      centered: config.centeredMobile
    };
  }

  function parseSlidesPerView(value) {
    if (value === 'auto') return 'auto';
    var n = parseFloat(value);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function viewportWidth(el) {
    var style = window.getComputedStyle(el);
    return (
      el.clientWidth -
      (parseFloat(style.paddingLeft) || 0) -
      (parseFloat(style.paddingRight) || 0)
    );
  }

  function getInstance(root) {
    if (instances) return instances.get(root);
    for (var i = 0; i < fallbackInstances.length; i++) {
      if (fallbackInstances[i].root === root) return fallbackInstances[i].instance;
    }
    return null;
  }

  function setInstance(root, instance) {
    if (instances) {
      instances.set(root, instance);
      return;
    }
    fallbackInstances.push({ root: root, instance: instance });
  }

  function deleteInstance(root) {
    if (instances) {
      instances.delete(root);
      return;
    }
    fallbackInstances = fallbackInstances.filter(function (entry) {
      return entry.root !== root;
    });
  }

  function initSlider(root) {
    var existing = getInstance(root);
    if (existing) existing.destroy();

    var track = root.querySelector('[data-miyo-track], .slider-track');
    if (!track) return;

    var originalSlides = Array.prototype.slice.call(track.children).filter(function (el) {
      return !el.hasAttribute('data-miyo-clone');
    });
    if (!originalSlides.length) return;

    var slides = originalSlides.slice();
    var dotsContainer = root.querySelector('[data-miyo-dots], .slider-dots');
    var prevBtn = root.querySelector('[data-miyo-prev]');
    var nextBtn = root.querySelector('[data-miyo-next]');
    var config = getConfig(root);
    var index = 0;
    var cloneCount = 0;
    var startX = 0;
    var currentX = 0;
    var isDragging = false;
    var dragDistance = 0;
    var startTranslate = 0;
    var slideWidth = 0;
    var maxIndex = 0;
    var didDrag = false;
    var destroyed = false;
    var looping = false;

    root.style.position = root.style.position || 'relative';
    if (window.getComputedStyle(root).overflowX === 'auto') {
      root.style.overflow = 'hidden';
    }
    track.style.display = 'flex';
    track.style.flexWrap = 'nowrap';
    track.style.willChange = 'transform';
    track.style.userSelect = 'none';

    function markImages() {
      var images = track.querySelectorAll('img');
      for (var imgIndex = 0; imgIndex < images.length; imgIndex++) {
        images[imgIndex].setAttribute('draggable', 'false');
      }
    }

    function desiredCloneCount() {
      if (!config.loop || originalSlides.length < 2) return 0;
      var spv = parseSlidesPerView(getViewport(config).slidesPerView);
      if (spv === 'auto') return Math.min(2, originalSlides.length);
      return Math.min(originalSlides.length, Math.max(1, Math.ceil(spv)));
    }

    function realIndex() {
      if (!looping || !originalSlides.length) return index;
      var i = index - cloneCount;
      return ((i % originalSlides.length) + originalSlides.length) % originalSlides.length;
    }

    function removeClones() {
      var clones = track.querySelectorAll('[data-miyo-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].parentNode.removeChild(clones[i]);
    }

    function setupClones() {
      var nextCloneCount = desiredCloneCount();
      var currentReal = originalSlides.length ? realIndex() : 0;
      if (
        nextCloneCount === cloneCount &&
        (nextCloneCount === 0 || track.querySelector('[data-miyo-clone]'))
      ) {
        looping = nextCloneCount > 0;
        slides = Array.prototype.slice.call(track.children);
        index = looping
          ? cloneCount + currentReal
          : Math.min(currentReal, Math.max(0, slides.length - 1));
        return;
      }
      looping = nextCloneCount > 0;
      cloneCount = nextCloneCount;
      removeClones();

      if (looping) {
        var i;
        for (i = 0; i < cloneCount; i++) {
          var srcBefore = originalSlides[originalSlides.length - cloneCount + i];
          var before = srcBefore.cloneNode(true);
          before.setAttribute('data-miyo-clone', 'before');
          before.setAttribute('aria-hidden', 'true');
          track.insertBefore(before, track.firstChild);
        }
        for (i = 0; i < cloneCount; i++) {
          var after = originalSlides[i].cloneNode(true);
          after.setAttribute('data-miyo-clone', 'after');
          after.setAttribute('aria-hidden', 'true');
          track.appendChild(after);
        }
      }

      slides = Array.prototype.slice.call(track.children);
      index = looping ? cloneCount + currentReal : Math.min(currentReal, Math.max(0, slides.length - 1));
      markImages();
    }

    function layout() {
      if (destroyed) return;
      var vp = getViewport(config);
      var spv = parseSlidesPerView(vp.slidesPerView);
      var gap = vp.gap;
      var containerWidth = viewportWidth(root);
      track.style.gap = gap + 'px';
      setupClones();

      if (spv === 'auto') {
        slides.forEach(function (slide) {
          slide.style.flex = '0 0 auto';
          slide.style.width = '';
          slide.style.maxWidth = '';
        });

        var total = 0;
        originalSlides.forEach(function (slide, i) {
          total += slide.getBoundingClientRect().width;
          if (i < originalSlides.length - 1) total += gap;
        });

        if (total <= containerWidth + 1) {
          looping = false;
          cloneCount = 0;
          removeClones();
          slides = originalSlides.slice();
          maxIndex = 0;
          index = 0;
        } else if (vp.centered || looping) {
          maxIndex = Math.max(0, originalSlides.length - 1);
        } else {
          maxIndex = 0;
          var acc = 0;
          for (var i = 0; i < originalSlides.length; i++) {
            if (total - acc <= containerWidth + 1) {
              maxIndex = i;
              break;
            }
            maxIndex = i;
            acc += originalSlides[i].getBoundingClientRect().width + gap;
          }
        }
        slideWidth = 0;
      } else {
        slideWidth = (containerWidth - gap * (spv - 1)) / spv;
        slides.forEach(function (slide) {
          slide.style.flex = '0 0 ' + slideWidth + 'px';
          slide.style.width = slideWidth + 'px';
          slide.style.maxWidth = slideWidth + 'px';
        });
        if (vp.centered || looping) {
          maxIndex = Math.max(0, originalSlides.length - 1);
        } else {
          maxIndex = Math.max(0, originalSlides.length - Math.ceil(spv - 0.001));
        }
      }

      if (!looping) index = Math.min(index, maxIndex);
      update(false);
      buildDots();
    }

    function itemOffset(i) {
      var vp = getViewport(config);
      var gap = vp.gap;
      var spv = parseSlidesPerView(vp.slidesPerView);
      var offset = 0;
      if (spv === 'auto') {
        for (var k = 0; k < i; k++) {
          offset += slides[k].getBoundingClientRect().width + gap;
        }
      } else {
        offset = i * (slideWidth + gap);
      }
      if (vp.centered && slides[i]) {
        var currentWidth =
          spv === 'auto' ? slides[i].getBoundingClientRect().width : slideWidth;
        offset -= (viewportWidth(root) - currentWidth) / 2;
      }
      return offset;
    }

    function snapLoop() {
      if (!looping) return;
      var firstReal = cloneCount;
      var lastReal = cloneCount + originalSlides.length - 1;
      if (index < firstReal) {
        index += originalSlides.length;
        update(false);
      } else if (index > lastReal) {
        index -= originalSlides.length;
        update(false);
      }
    }

    function update(animate) {
      if (destroyed) return;
      if (animate === undefined) animate = true;
      var duration = animate ? config.duration : 0;
      track.style.transition = duration ? 'transform ' + duration + 'ms ease' : 'none';
      track.style.transform = 'translateX(' + -itemOffset(index) + 'px)';
      updateDots();
      updateArrows();
      updateSlideStates();
    }

    function updateSlideStates() {
      var vp = getViewport(config);
      var spv = parseSlidesPerView(vp.slidesPerView);
      var visibleStart;
      var visibleEnd;
      if (spv === 'auto') {
        visibleStart = index;
        visibleEnd = index;
      } else if (vp.centered) {
        var side = Math.floor(spv / 2);
        visibleStart = index - side;
        visibleEnd = index + side;
      } else {
        visibleStart = index;
        visibleEnd = index + Math.floor(spv) - 1;
      }

      slides.forEach(function (slide, i) {
        var fullyVisible = i >= visibleStart && i <= visibleEnd;
        slide.classList.toggle('is-active', i === index);
        slide.classList.toggle('is-visible', fullyVisible);
        slide.classList.toggle('is-prev', i === index - 1);
        slide.classList.toggle('is-next', i === index + 1);
      });
    }

    function buildDots() {
      if (!dotsContainer) return;
      var count = maxIndex + 1;
      dotsContainer.hidden = count <= 1;
      if (dotsContainer.childElementCount !== count) {
        dotsContainer.innerHTML = '';
        for (var i = 0; i < count; i++) {
          (function (dotIndex) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.setAttribute('aria-label', 'Slide ' + (dotIndex + 1));
            btn.addEventListener('click', function () {
              index = looping ? cloneCount + dotIndex : dotIndex;
              update();
            });
            dotsContainer.appendChild(btn);
          })(i);
        }
      }
      updateDots();
    }

    function updateDots() {
      if (!dotsContainer) return;
      var current = realIndex();
      var buttons = dotsContainer.querySelectorAll('button');
      for (var i = 0; i < buttons.length; i++) {
        var isActive = i === current;
        buttons[i].classList.toggle('active', isActive);
        buttons[i].classList.toggle('is-active', isActive);
      }
    }

    function updateArrows() {
      var atStart = !looping && index <= 0;
      var atEnd = !looping && index >= maxIndex;
      if (prevBtn) {
        prevBtn.classList.toggle('is-disabled', atStart);
        prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (nextBtn) {
        nextBtn.classList.toggle('is-disabled', atEnd);
        nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    }

    function go(delta) {
      if (looping) index += delta;
      else index = Math.max(0, Math.min(index + delta, maxIndex));
      update();
    }

    function onPrev(e) {
      e.preventDefault();
      if (!looping && index <= 0) return;
      go(-1);
    }

    function onNext(e) {
      e.preventDefault();
      if (!looping && index >= maxIndex) return;
      go(1);
    }

    function onTransitionEnd(e) {
      if (e.target !== track) return;
      if (e.propertyName && e.propertyName !== 'transform') return;
      snapLoop();
    }

    function dragStart(x) {
      isDragging = true;
      didDrag = false;
      startX = x;
      currentX = x;
      dragDistance = 0;
      startTranslate = -itemOffset(index);
      track.style.transition = 'none';
    }

    function dragMove(x) {
      if (!isDragging) return;
      currentX = x;
      dragDistance = currentX - startX;
      if (Math.abs(dragDistance) > 5) didDrag = true;
      track.style.transform = 'translateX(' + (startTranslate + dragDistance) + 'px)';
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;
      if (didDrag) {
        if (dragDistance > 50) go(-1);
        else if (dragDistance < -50) go(1);
        else update();
      } else {
        update();
      }
    }

    function onTouchStart(e) {
      dragStart(e.touches[0].clientX);
    }

    function onTouchMove(e) {
      if (!isDragging) return;
      dragMove(e.touches[0].clientX);
    }

    function onTouchEnd() {
      dragEnd();
    }

    function onMouseDown(e) {
      if (e.button !== 0) return;
      dragStart(e.clientX);
    }

    function onMouseMove(e) {
      dragMove(e.clientX);
    }

    function onMouseUp() {
      dragEnd();
    }

    function onClickCapture(e) {
      if (!didDrag) return;
      e.preventDefault();
      e.stopPropagation();
      didDrag = false;
    }

    function onResize() {
      layout();
    }

    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);
    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: true });
    track.addEventListener('touchend', onTouchEnd);
    track.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    track.addEventListener('click', onClickCapture, true);
    track.addEventListener('transitionend', onTransitionEnd);
    window.addEventListener('resize', onResize);

    layout();

    var instance = {
      destroy: function () {
        if (destroyed) return;
        destroyed = true;
        if (prevBtn) prevBtn.removeEventListener('click', onPrev);
        if (nextBtn) nextBtn.removeEventListener('click', onNext);
        track.removeEventListener('touchstart', onTouchStart);
        track.removeEventListener('touchmove', onTouchMove);
        track.removeEventListener('touchend', onTouchEnd);
        track.removeEventListener('mousedown', onMouseDown);
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        track.removeEventListener('click', onClickCapture, true);
        track.removeEventListener('transitionend', onTransitionEnd);
        window.removeEventListener('resize', onResize);
        removeClones();
        deleteInstance(root);
      }
    };

    setInstance(root, instance);
    return instance;
  }

  function matchesSlider(el) {
    return (
      el &&
      el.nodeType === 1 &&
      (el.hasAttribute('data-miyo-slider') ||
        (el.classList && el.classList.contains('slider') && el.classList.contains('pro_cate_slider')))
    );
  }

  function initMiyoSliders(scope) {
    var rootEl = scope && scope.querySelectorAll ? scope : document;
    if (matchesSlider(rootEl)) initSlider(rootEl);
    var nodes = rootEl.querySelectorAll
      ? rootEl.querySelectorAll('[data-miyo-slider], .pro_cate_slider.slider')
      : [];
    for (var i = 0; i < nodes.length; i++) initSlider(nodes[i]);
  }

  window.initMiyoSliders = initMiyoSliders;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMiyoSliders();
    });
  } else {
    initMiyoSliders();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMiyoSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    var nodes = event.target.querySelectorAll(
      '[data-miyo-slider], .pro_cate_slider.slider'
    );
    for (var i = 0; i < nodes.length; i++) {
      var inst = getInstance(nodes[i]);
      if (inst) inst.destroy();
    }
  });
})(window, document);
